var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M9 4.5h11l3.5 6.5v5.5h-2.55a2.5 2.5 0 00-4.9 0h-6.1A2.503 2.503 0 008 14.55c-2-.35-2.9 1.2-3 1.95H.5V11l5-1.5 3.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M10 17a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm11 0a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"
  }));
}
export default SvgIconCar;